<div class="heading-section" [ngClass]="hsClass">
  <h2 *ngIf="title" class="hs-title" [ngClass]="{'inner': innerColor}">
    {{ title }}
  </h2>
  <span> - {{subtitle}}</span>
</div>
